// Map constants based on Android MapHelper
export const MapHelper = {
  // Source and Layer IDs
  MAP_SOURCE_ID: 'pempem_source',
  MAP_LAYER_ID: 'pempem_layer',
  // API endpoint. Returns flat rows ({ prices: [...] }), not a TileJSON - see millPriceOnMap.ts.
  NAM_PRICES_SOURCE_URL_PATH: '/mapTilingService/prices?token=',

  // Price types
  PRICE_TYPE_BID: 'bid',
  PRICE_TYPE_BID_QBP: 'bid_qbp',
  PRICE_TYPE_BID_GROUP: 'bid_group',

  // Feature Properties - Price
  FEATURE_PROPERTY_ID: 'id',
  FEATURE_PROPERTY_PRICE_TYPE: 'price_type',
  FEATURE_PROPERTY_PRICE_COUNT: 'price_count',
  FEATURE_PROPERTY_GROUP_ID: 'group_id',
  FEATURE_GRADING_RATIO: 'standard_grading_ratio',
  FEATURE_PROPERTY_PROGRAM_NAME: 'program_name',
  FEATURE_WARNING_MESSAGE: 'bid_warning_message',
  FEATURE_PROPERTY_SPSI_INCLUDED: 'unloading_fee_pre_applied',
  FEATURE_PROPERTY_PRICE_PER_UNIT: 'price_per_kg',
  FEATURE_PROPERTY_PROGRAM_DELTA_BONUS: 'program_delta_bonus',
  FEATURE_PROPERTY_QUALITY_PRICES: 'tiers',

  // Feature Properties - Organization
  FEATURE_PROPERTY_ORGANIZATION_ID: 'mill_id',
  FEATURE_PROPERTY_ORGANIZATION_NAME: 'mill_full_name',
  FEATURE_PROPERTY_MILL_USE_NE_MOBILE: 'accepts_dropoff',
  FEATURE_PROPERTY_SPB_DOCUMENT: 'require_spb',
  FEATURE_PROPERTY_SORTING_STRICTNESS: 'sorting_strictness',
  FEATURE_PROPERTY_MINIMUM_QUALITY_LEVEL: 'minimum_quality_level',

  // Feature Properties - Location
  FEATURE_PROPERTY_LOCATION_VILLAGE: 'location_village',
  FEATURE_PROPERTY_LOCATION_SUB_DISTRICT: 'location_subdistrict',

  // Mill Officer
  FEATURE_PROPERTY_MILL_OFFICER_NAME: 'mill_officer_name',
  FEATURE_PROPERTY_MILL_OFFICER_PHONE: 'mill_officer_phonenumber',

  // Helper to calculate distance (Haversine formula)
  calculateDistanceTo: (point: [number, number], userLocation: [number, number] | null): number => {
    if (!userLocation) return 0;
    
    const [lon1, lat1] = point;
    const [lon2, lat2] = userLocation;
    
    const R = 6371e3; // Earth's radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;
    
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    
    return R * c; // Distance in meters
  },
  
  // Parse quality price levels from JSON string
  buildQualityPriceLevels: (qualityPricesJson: string | null): any[] => {
    if (!qualityPricesJson) return [];
    try {
      return JSON.parse(qualityPricesJson);
    } catch {
      return [];
    }
  },
};
